import { ReactNode } from 'react'
import { StackedAlertsProvider } from './StackedAlertsContext'

interface StackedAlertsContainerProps {
  children: ReactNode
  baseOffset?: number
  gap?: number
}

/**
 * Wrapper that provides stacking context to child AlertContainers.
 * Alerts inside this container will be positioned directly using bottom offset,
 * rather than using full-viewport overlays.
 *
 * The order of children determines stacking: first child is at the bottom,
 * subsequent children stack above.
 */
const StackedAlertsContainer = ({ children, baseOffset = 80, gap = 16 }: StackedAlertsContainerProps) => {
  return (
    <StackedAlertsProvider baseOffset={baseOffset} gap={gap}>
      {children}
    </StackedAlertsProvider>
  )
}

export default StackedAlertsContainer
